module.exports = __webpack_public_path__ + "img/es.f2c84a90.jpg";